<template>
    <div class="play-back-list">
        <p class="month-title">{{ title }}</p>
        <div class="live-item-parent">
            <play-back-item :itemData="lessonData"></play-back-item>
        </div>
    </div>
</template>

<script>
import PlayBackItem from '@components/playBackList/PlayBackItem';
import moment from '@plugins/_moment';
export default {
    name: 'PlayBackList',
    components: {
        PlayBackItem
    },
    props: {
        listData: {
            require: true,
            type: Array
        },
        title: {
            require: true,
            type: String
        }
    },
    data() {
        return {};
    },
    computed: {
        lessonData() {
            const { listData } = this;
            const data = {};
            for (let i = 0; i < listData.length; i++) {
                const element = listData[i];
                const startTime = moment(element.show_time);
                const key = startTime.format('yyyy-MM-DD');
                const value = data[key];
                if (!value) {
                    data[key] = [];
                }
                data[key].push(element);
            }
            // listData.foreach((item) => {
            //     const startTime = moment(item.show_time_str);
            //     const k = startTime.format('MM月DD日');
            //     const value = data[k];
            //     if (!value) {
            //         data[k] = [];
            //     }
            //     data[k].push(item);
            // });
            return data;
        }
    },
    created() {
        // console.log(this.listData);
    }
};
</script>
<style lang="scss" scoped>
.play-back-list {
    box-sizing: border-box;
    padding: 25px 25px 25px 40px;
}
.month-title {
    box-sizing: border-box;
    width: 124px;
    line-height: 32px;
    background: url('~@images/base/time-bg.png') no-repeat center;
    padding-left: 38px;
    color: #fff;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    margin-bottom: 25px;
}
.live-item-parent:not(:last-child) {
    margin-bottom: 30px;
}
</style>
